import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { timer } from 'rxjs';

@Component({
  selector: 'app-digital-clock',
  standalone: true,
  imports: [],
  templateUrl: './digital-clock.component.html',
  styleUrls: ['./digital-clock.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DigitalClockComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  private static readonly DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  private static readonly MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

  dayName = '';
  dayNum = '';
  monthName = '';
  timeStr = '';

  ngOnInit(): void {
    timer(0, 1000)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this._tick();
        this.cdr.markForCheck();
      });
  }

  private _tick(): void {
    const now = new Date();
    this.dayName = DigitalClockComponent.DAYS[now.getDay()];
    this.dayNum = String(now.getDate()).padStart(2, '0');
    this.monthName = DigitalClockComponent.MONTHS[now.getMonth()];
    this.timeStr = now.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  }
}
